module.exports = __webpack_public_path__ + "static/media/id2-worlds_paths.086d2c49.jpg";